<template>
  <div class="punk-detail-body">
    <div class="punk-detail-media">
      <div class="punk-detail-image">
        <img
          v-if="punk.image"
          :src="punk.image"
          :alt="punk.name"
        >
        <LoadingSpinner v-else-if="!punk.error" />
      </div>
      <a
        class="command_button opensea-button"
        :href="openSeaURL"
        target="_blank"
        rel="noopener"
      >
        <img
          src="@/assets/img/opensea.png"
          alt=""
        >
        View on OpenSea
      </a>
      <button
        class="command_button punk-suit-up"
        :disabled="punk.error"
        @click="$emit('suit-up', punk.id)"
      >
        Suit Up
      </button>
      <div class="punk-downloads">
        <button
          class="command_button"
          :disabled="!punk.image || !!exporting"
          @click="download('png')"
        >
          {{ exporting === 'png' ? 'Saving...' : 'Download PNG' }}
        </button>
        <button
          class="command_button"
          :disabled="!punk.image || !!exporting"
          @click="download('gif')"
        >
          {{ exporting === 'gif' ? 'Making GIF...' : 'Download GIF' }}
        </button>
      </div>
    </div>
    <div class="punk-detail-info">
      <h2>{{ punk.name }}</h2>
      <table
        v-if="punk.attributes"
        class="punk-attributes"
      >
        <tr
          v-for="attribute in punk.attributes"
          :key="attribute.trait_type"
        >
          <th>{{ attribute.trait_type }}</th>
          <td>{{ attribute.value }}</td>
        </tr>
      </table>
      <p v-else-if="punk.error">
        Couldn't load this punk's metadata.
      </p>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { RPUNKS_ADDRESS } from '@/web3'
import { downloadBlob, renderPunkGIF, renderPunkPNG } from '@/punkImage'

// a punk's image, attributes and OpenSea link; shared by the Your RPUNKS and RPUNK Lookup windows
export default {
  name: 'PunkDetail',
  components: {
    LoadingSpinner
  },
  props: {
    // { id, name, image, attributes, error }
    punk: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      exporting: ''
    }
  },
  computed: {
    openSeaURL () {
      return `https://opensea.io/assets/ethereum/${RPUNKS_ADDRESS}/${this.punk.id}`
    }
  },
  methods: {
    // 720x720 png still, or a 720x720 gif of one seamless glow loop
    async download (format) {
      this.exporting = format
      try {
        const render = format === 'gif' ? renderPunkGIF : renderPunkPNG
        downloadBlob(await render(this.punk.image), `radioactive-punk-${this.punk.id}.${format}`)
      } catch (e) {
        console.warn(e)
        window.alert(`Couldn't make a ${format.toUpperCase()} of this punk.`)
      } finally {
        this.exporting = ''
      }
    }
  }
}
</script>

<style lang="scss">
.punk-detail {
  .back-button {
    margin-bottom: 10px;
  }
}

.punk-detail-body {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  h2 {
    margin: 0 0 0.5em;
  }
}

.punk-detail-media {
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.punk-detail-image {
  width: 220px;
  height: 220px;
  border: 1px solid #111;
  background: #e9f7de;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    width: 100%;
    height: 100%;
    image-rendering: pixelated;
  }
}

.punk-detail-info {
  flex: 1;
  min-width: 180px;
  max-width: 360px;
}

.punk-attributes {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 12px;

  th,
  td {
    text-align: left;
    padding: 2px 6px;
    border-bottom: 1px dotted #999;
    font-size: 0.9rem;
  }

  th {
    font-weight: bold;
    white-space: nowrap;
  }
}

.punk-suit-up {
  padding: 3px 0;
}

.punk-downloads {
  display: flex;
  gap: 6px;

  button {
    flex: 1;
    padding: 3px 0;
  }
}

.opensea-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 3px 8px;
  border: 1px solid #111;
  border-radius: 3px;
  background: #efefef;
  text-decoration: none;
  color: inherit;

  &:hover {
    background: #e0e0e0;
  }

  img {
    width: 16px;
  }
}
</style>
